import { MapScopedKeyMap } from 'ia-react-core/~/interfaces/MapScopedKeyMap';
import getDst from './#getDst';

export default function getDataDst<
Target extends Partial<Record<
  'dataDst' | 'dataSrc',
    string | MapScopedKeyMap<{ resourceId: number }> |((props: Record<'resourceId', number>) => string)
>> & Partial<Record<'resourceId', number>>
>(props: Target): string {
  return getDst('data', props, { idName: 'resourceId' });
}
